/**
 * Tax Exempt Status Section JavaScript
 * Premium functionality for document viewing and interactions
 */

(function() {
  'use strict';

  // Global function to open tax document in new window
  window.openTaxDocument = function(documentUrl) {
    if (!documentUrl) {
      console.warn('No document URL provided');
      return;
    }

    try {
      // Open document in a new window/tab
      const newWindow = window.open(
        documentUrl,
        'tax-document',
        'width=1200,height=800,scrollbars=yes,resizable=yes,toolbar=no,menubar=no'
      );

      // Check if popup was blocked
      if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        // Fallback: try to open in same tab
        showNotification('Popup blocked. Opening document in new tab...', 'info');
        window.open(documentUrl, '_blank');
      } else {
        // Focus the new window
        newWindow.focus();
        showNotification('Document opened in new window', 'success');
      }

      // Track document view (optional analytics)
      if (typeof gtag !== 'undefined') {
        gtag('event', 'view_tax_document', {
          'event_category': 'tax_exempt',
          'event_label': 'document_view'
        });
      }

    } catch (error) {
      console.error('Error opening tax document:', error);
      showNotification('Error opening document. Please try again.', 'error');
    }
  };

  // Notification system
  function showNotification(message, type = 'info') {
    // Remove existing notifications
    const existingNotifications = document.querySelectorAll('.tax-exempt-notification');
    existingNotifications.forEach(notification => notification.remove());

    // Create notification element
    const notification = document.createElement('div');
    notification.className = `tax-exempt-notification tax-exempt-notification--${type}`;
    notification.innerHTML = `
      <div class="tax-exempt-notification__content">
        <span class="tax-exempt-notification__message">${message}</span>
        <button class="tax-exempt-notification__close" onclick="this.parentElement.parentElement.remove()">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
          </svg>
        </button>
      </div>
    `;

    // Add notification styles
    const notificationStyles = `
      .tax-exempt-notification {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        max-width: 400px;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        font-size: 14px;
        animation: slideInRight 0.3s ease-out;
      }

      .tax-exempt-notification--success {
        background: #10b981;
        color: white;
      }

      .tax-exempt-notification--error {
        background: #ef4444;
        color: white;
      }

      .tax-exempt-notification--info {
        background: #2563eb;
        color: white;
      }

      .tax-exempt-notification--warning {
        background: #f59e0b;
        color: white;
      }

      .tax-exempt-notification__content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
      }

      .tax-exempt-notification__message {
        flex: 1;
      }

      .tax-exempt-notification__close {
        background: none;
        border: none;
        color: currentColor;
        cursor: pointer;
        padding: 0;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.8;
        transition: opacity 0.2s ease;
      }

      .tax-exempt-notification__close:hover {
        opacity: 1;
      }

      .tax-exempt-notification__close svg {
        width: 16px;
        height: 16px;
      }

      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
    `;

    // Add styles to head if they don't exist
    if (!document.querySelector('#tax-exempt-notification-styles')) {
      const styleSheet = document.createElement('style');
      styleSheet.id = 'tax-exempt-notification-styles';
      styleSheet.textContent = notificationStyles;
      document.head.appendChild(styleSheet);
    }

    // Add notification to page
    document.body.appendChild(notification);

    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.style.animation = 'slideInRight 0.3s ease-out reverse';
        setTimeout(() => notification.remove(), 300);
      }
    }, 5000);
  }

  // Enhanced expiration countdown functionality
  function initExpirationCountdown() {
    const warningBadges = document.querySelectorAll('.countdown-badge.warning');
    const expiredMessages = document.querySelectorAll('.expired-message');
    const expiredPanels = document.querySelectorAll('.expired-panel');
    
    // Handle warning badges
    warningBadges.forEach(badge => {
      const warningLabel = badge.querySelector('.warning-label');
      if (!warningLabel) return;
      
      // Add enhanced animations for warning badges
      badge.style.animation = 'warningPulse 2s infinite';
      
      // Add extra urgency if very close to expiration
      const expirationDate = document.querySelector('.expiry-date');
      if (expirationDate) {
        const dateTimeAttr = expirationDate.getAttribute('datetime');
        if (dateTimeAttr) {
          const expiryDate = new Date(dateTimeAttr);
          const today = new Date();
          const timeDiff = expiryDate.getTime() - today.getTime();
          const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
          
          if (daysDiff <= 3) {
            badge.classList.add('critical');
            badge.style.animation = 'urgentPulse 1s infinite';
          }
        }
      }
    });
    
    // Handle expired status styling
    expiredMessages.forEach(message => {
      message.style.animation = 'shake 3s ease-in-out infinite';
    });
    
    expiredPanels.forEach(panel => {
      panel.style.animation = 'shake 2s ease-in-out infinite';
    });

    // Auto-update countdown for real-time accuracy
    if (warningBadges.length > 0 || expiredMessages.length > 0) {
      updateCountdownDisplay();
      // Update every hour
      setInterval(updateCountdownDisplay, 3600000);
    }
  }

  // Real-time countdown update function
  function updateCountdownDisplay() {
    const expirationDates = document.querySelectorAll('.expiry-date');
    const daysRemainingElements = document.querySelectorAll('.days-remaining-number');
    const expiredMessages = document.querySelectorAll('.expired-message');
    
    expirationDates.forEach((dateElement, index) => {
      const dateTimeAttr = dateElement.getAttribute('datetime');
      if (!dateTimeAttr) return;
      
      const expiryDate = new Date(dateTimeAttr);
      const today = new Date();
      const timeDiff = expiryDate.getTime() - today.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      
      // Update days remaining display if element exists and not expired
      const daysElement = daysRemainingElements[index];
      if (daysElement && daysDiff >= 0) {
        daysElement.textContent = daysDiff;
        
        // Update parent elements styling based on days remaining
        const badge = document.querySelector('.countdown-badge.warning');
        if (badge && daysDiff <= 3) {
          badge.classList.add('critical');
        }
      }
      
      // Handle expired status - show notification if just expired
      if (daysDiff < 0 && expiredMessages.length > 0) {
        const expiredMessage = expiredMessages[index];
        if (expiredMessage && !expiredMessage.classList.contains('notified')) {
          showNotification('Tax exempt status has expired. Please update your documentation.', 'error');
          expiredMessage.classList.add('notified');
        }
      }
    });
  }

  // Add additional animations for urgent expiration
  function addUrgentStyles() {
    const urgentStyles = `
      @keyframes urgentPulse {
        0%, 100% { 
          box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.7);
          transform: scale(1);
        }
        50% { 
          box-shadow: 0 0 0 8px rgba(245, 158, 11, 0);
          transform: scale(1.03);
        }
      }

      .countdown-badge.critical {
        animation: urgentPulse 1s infinite !important;
        background: linear-gradient(135deg, #dc2626, #b91c1c) !important;
      }

      .countdown-badge.urgent {
        animation: warningPulse 1.5s infinite !important;
      }

      .view-btn {
        border-radius: 50px !important;
        font-size: clamp(1.125rem, 3vw, 1.375rem) !important;
      }

      .view-btn:focus {
        outline: 3px solid rgba(37, 99, 235, 0.5);
        outline-offset: 2px;
      }
    `;

    if (!document.querySelector('#tax-exempt-urgent-styles')) {
      const styleSheet = document.createElement('style');
      styleSheet.id = 'tax-exempt-urgent-styles';
      styleSheet.textContent = urgentStyles;
      document.head.appendChild(styleSheet);
    }
  }

  // Keyboard navigation support
  function initKeyboardNavigation() {
    const interactiveElements = document.querySelectorAll(
      '.tax-exempt-modern button, .tax-exempt-modern a'
    );

    interactiveElements.forEach((element, index) => {
      element.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
        
        // Arrow key navigation
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          const nextElement = interactiveElements[index + 1];
          if (nextElement) nextElement.focus();
        }
        
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevElement = interactiveElements[index - 1];
          if (prevElement) prevElement.focus();
        }
      });
    });
  }

  // Status card hover effects enhancement
  function initStatusCardEffects() {
    const statusCards = document.querySelectorAll('.status-card, .document-card');
    
    statusCards.forEach(card => {
      if (!card) return;

      // Add subtle parallax effect on mouse move
      card.addEventListener('mousemove', function(e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const rotateX = (y - centerY) / 30;
        const rotateY = (centerX - x) / 30;
        
        this.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
      });

      card.addEventListener('mouseleave', function() {
        this.style.transform = '';
      });
    });

    // Enhanced button interactions
    const viewButtons = document.querySelectorAll('.view-btn');
    viewButtons.forEach(button => {
      button.addEventListener('mouseenter', function() {
        this.style.transform = 'translateY(-3px) scale(1.02)';
      });
      
      button.addEventListener('mouseleave', function() {
        this.style.transform = '';
      });
    });
  }

  // Performance monitoring
  function initPerformanceMonitoring() {
    // Monitor section load time
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      entries.forEach((entry) => {
        if (entry.name.includes('tax-exempt-status')) {
          console.log(`Tax Exempt Section loaded in ${entry.duration}ms`);
        }
      });
    });
    
    observer.observe({ entryTypes: ['measure', 'navigation'] });
  }

  // Drag and drop uploader and form helpers
  function initUploadUI() {
    const card = document.getElementById('tax-exempt-upload');
    if (!card) return;

    const dropzone = document.getElementById('taxDropzone');
    const input = document.getElementById('taxDocFile');
    const chooseBtn = document.getElementById('taxDropzoneButton');
    const filename = document.getElementById('taxDropzoneFilename');

    function setFile(f) {
      if (!f) return;
      input.files = (() => {
        const dt = new DataTransfer();
        dt.items.add(f);
        return dt.files;
      })();
      filename.textContent = f.name;
    }

    // Click to open
    chooseBtn && chooseBtn.addEventListener('click', () => input.click());
    dropzone && dropzone.addEventListener('click', (e) => {
      // only click on container if not clicking the button (already handled)
      if (e.target === dropzone) input.click();
    });

    // Keyboard support
    dropzone && dropzone.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        input.click();
      }
    });

    // Drag events
    ['dragenter', 'dragover'].forEach(evt => {
      dropzone && dropzone.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.add('dragover');
      });
    });
    ['dragleave', 'drop'].forEach(evt => {
      dropzone && dropzone.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.remove('dragover');
      });
    });
    dropzone && dropzone.addEventListener('drop', (e) => {
      const file = e.dataTransfer?.files?.[0];
      if (file) setFile(file);
    });

    // Input change
    input && input.addEventListener('change', () => {
      const file = input.files?.[0];
      if (file) filename.textContent = file.name;
    });
  }

  // Initialize all functionality when DOM is ready
  function init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Initialize all features
    initExpirationCountdown();
    addUrgentStyles();
    initKeyboardNavigation();
    initStatusCardEffects();
    initUploadUI();
    
    // Performance monitoring in development
    if (window.location.hostname === 'localhost' || window.location.hostname.includes('myshopify.com')) {
      initPerformanceMonitoring();
    }
    
    // Initialize real-time updates for expiration tracking
    if (document.querySelector('.expiry-date')) {
      console.log('Tax Exempt Status: Real-time expiration tracking initialized');
    }

    console.log('Tax Exempt Status section initialized');
  }

  // Start initialization
  init();

  // Expose utility functions globally
  window.TaxExemptStatus = {
    showNotification: showNotification,
    openDocument: window.openTaxDocument
  };

})();
